import { Clock, FlaskConical, KeyRound, Sparkles } from 'lucide-react';
import type { Integration } from '@/api/types';
import { Badge } from '@/components/ui';

const STATUS_LABEL: Record<Integration['status'], string> = {
  available: 'Available',
  beta: 'Beta',
  byo_credentials: 'Bring your own keys',
  partner_required: 'Coming soon',
};

export function StatusBadge({ status }: { status: Integration['status'] }) {
  switch (status) {
    case 'available':
      return (
        <Badge tone="good" icon={<Sparkles className="size-3" aria-hidden />}>
          {STATUS_LABEL.available}
        </Badge>
      );
    case 'beta':
      return (
        <Badge tone="outline" icon={<FlaskConical className="size-3" aria-hidden />}>
          {STATUS_LABEL.beta}
        </Badge>
      );
    case 'byo_credentials':
      return (
        <Badge tone="outline" icon={<KeyRound className="size-3" aria-hidden />}>
          {STATUS_LABEL.byo_credentials}
        </Badge>
      );
    case 'partner_required':
      return (
        <Badge tone="neutral" icon={<Clock className="size-3" aria-hidden />}>
          {STATUS_LABEL.partner_required}
        </Badge>
      );
  }
}

export function DemoBadge() {
  return (
    <Badge tone="yellow" className="uppercase tracking-wide text-[10px]">
      Demo data
    </Badge>
  );
}
